/**
 * Patches the GWP Sample Widget promotion methods to use product ID comparison
 * instead of object reference equality (Array.includes).
 *
 * The Rebuy SDK clones widget data when initializing Vue components, so the
 * product objects in the Vue template (vm.$data.products) are different instances
 * from the ones stored in promotion.sampleProducts / promotion.eligibleProducts.
 * Array.includes() uses strict reference equality (===), causing all visibility
 * and eligibility checks to fail.
 */
(function () {
  function patch(promo) {
    if (promo._patched) return;
    promo._patched = true;

    function byId(arr, product) {
      return arr.some(function (p) { return p.id === product.id; });
    }

    function findTier(product) {
      return promo.tiers.find(function (t) {
        return t.products && t.products.some(function (p) { return p.id === product.id; });
      });
    }

    function findInternal(product) {
      return promo.allProducts.find(function (p) { return p.id === product.id; });
    }

    promo.isVisible = function (product) {
      if (this.promotionType === 'gifts') return byId(this.giftProducts, product);
      if (this.promotionType === 'samples') return byId(this.sampleProducts, product);
      if (this.promotionType === 'all') return true;
      return false;
    };

    promo.isInteractive = function (product) {
      var interactive = false;
      var tier = findTier(product);
      if (!tier) return false;

      if (byId(this.eligibleProducts, product)) interactive = true;
      if (tier.redeemed && tier.redeemed.length >= tier.limit) interactive = false;

      if (
        (tier.type === 'Free Gift' && this.redeemedGiftItems.length >= this.completedGiftTiers.length) ||
        (tier.type === 'Free Sample' && this.redeemedSampleItems.length >= this.completedSampleTiers.length)
      ) interactive = false;

      if (byId(this.redeemedProducts, product)) interactive = true;

      return interactive;
    };

    promo.buttonLabel = function (product) {
      if (byId(this.redeemedProducts, product)) {
        return product.status === 'removing' ? 'Removing' : 'Remove';
      }
      if (byId(this.eligibleProducts, product)) {
        return product.status === 'adding' ? 'Choosing' : 'Choose';
      }
      var tier = findTier(product);
      if (tier && tier.remaining > 0) {
        return 'Spend ' + window.Rebuy.util.formatMoney(tier.remaining) + ' More';
      }
      return 'here';
    };

    promo.selectProduct = function (product, tiers, widget) {
      product.status = 'adding';
      var tier = findTier(product);
      var cartData = widget.addToCartData(product);

      if (tier && tier.redeemed.length === tier.limit) {
        var last = tier.redeemed[tier.redeemed.length - 1];
        last.status = 'removing';
        window.Rebuy.Cart.removeItem(last.item, function () {
          window.Rebuy.Cart.addItem(cartData);
        });
      } else {
        window.Rebuy.Cart.addItem(cartData);
      }
      product.status = 'ready';
    };

    promo.removeProduct = function (product) {
      product.status = 'removing';
      var internal = findInternal(product);
      if (internal && internal.item) {
        window.Rebuy.SmartCart.removeItem(internal.item);
      }
      product.status = 'ready';
    };
  }

  if (window.promotion) {
    patch(window.promotion);
  } else {
    var observer = new MutationObserver(function () {
      if (window.promotion && !window.promotion._patched) {
        patch(window.promotion);
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 15000);
  }
})();
